import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../navbar/Header';

import Get_Start_Button from './Get_Started_Button';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth) {
      navigate("/dashboard");
    }
  }, [navigate]);

  // Embedded CSS styles
  const styles = {
    container: {
      backgroundImage: "url('/images/image1.png')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh',
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
    },
    contentBox: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      padding: '40px',
      borderRadius: '16px',
      maxWidth: '600px',
      width: '90%',
    },
    heading: {
      fontSize: '3rem',
      marginBottom: '20px',
    },
    description: {
      fontSize: '1.2rem',
      marginBottom: '30px',
    }
  };

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.contentBox}>
        <h1 style={styles.heading}>Welcome to PicAura</h1>
        <h4 >
  Shoot. Upload. We’ll Handle the Rest.
</h4>
<p className="intro-text">
  PicAura simplifies your photography workflow — whether you're covering weddings, parties, or corporate events. Just capture the moments, upload your photos, and let our facial recognition technology securely deliver each guest their own memories. No manual sorting. No endless requests. Just smart, seamless sharing — all under your control.
</p>

        <Get_Start_Button />
      </div>
    </div>
  );
};

export default Home;
